import { getReceive, getReceiveById, updateReceive, createReceive, deleteReceive, invalidReceive, getReceiveStat, getCustomerDefaultReceiveInfo } from '@/api/receive'
import Vue from 'vue'

const state = {
  receiveList: [],
  receiveStatList: [],
  totalCounts: 0,
  billsList: [],
}

const getters = {
}

const actions = {
  async getReceiveAction({ commit }, payload) {
    try {
      const res = await getReceive(payload)
      commit('SET_RECEIVE', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async getReceiveByIdAction({ commit }, id) {
    try {
      const receive = await getReceiveById(id)
      return receive.data
    } catch (error) {
      throw error.message
    }
  },
  async createReceiveAction({ commit }, payload) {
    try {
      const newReceive = await createReceive(payload);
      commit('ADD_RECEIVE', newReceive.data)
    } catch (error) {
      throw error.message
    }
  },

  async updateReceiveAction({ commit }, payload) {
      try {
          const newReceive = await updateReceive(payload.id, payload.data)
          commit("UPDATE_RECEIVE", newReceive.data)
          return newReceive.data
      } catch (error) {
          throw error.message
      }
  },
  async updateLocalReceiveAction({ commit }, payload) {
      try {
          commit("UPDATE_LOCAL_RECEIVE", payload)
      } catch (error) {
          throw error.message
      }
  },
  async invalidReceiveAction({ commit }, payload) {
      try {
        const newReceive = await invalidReceive(payload.id, payload.data)
          commit("INVALID_RECEIVE", payload)
          return newReceive
      } catch (error) {
          throw error.message
      }
  },
  async deleteReceiveAction({ commit }, payload) {
    try {
      await deleteReceive(payload)
      commit('DELETE_RECEIVE', payload)
    } catch (error) {
      throw error.message
    }
  },

  async getReceiveStatAction({ commit }, payload) {
    try {
      const res = await getReceiveStat(payload)
      commit('SET_RECEIVE_STAT', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },

  async getCustomerDefaultReceiveInfoAction({ commit }, id) {
    try {
      const receive = await getCustomerDefaultReceiveInfo(id)
      return receive.data
    } catch (error) {
      throw error.message
    }
  },
}

const mutations = {
  SET_RECEIVE(state, payload) {
    state.receiveList = payload.receiveList
    state.totalCounts = payload.totalCounts
  },
  UPDATE_RECEIVE(state, receive) {
    Vue.set(state.receiveList, state.receiveList.findIndex(x => x._id === receive._id), receive)
  },
  UPDATE_LOCAL_RECEIVE(state, payload) {
    const index = state.receiveList.findIndex(x => x._id === payload.id)
    const newReceive = state.receiveList[index]
    newReceive.bill = payload.data
    newReceive.amount = payload.data.amount
    Vue.set(state.receiveList, state.receiveList.findIndex(x => x._id === payload._id), newReceive)
  },
  INVALID_RECEIVE(state, receive) {
    if (receive.data.invalid) {
      state.receiveList = state.receiveList.filter(e => e._id !== receive.id)
      state.totalCounts--
    } else {
      const index = state.receiveList.findIndex(x => x._id === receive.id)
      const newReceive = state.receiveList[index]
      newReceive.invalid = false
      Vue.set(state.receiveList, state.receiveList.findIndex(x => x._id === receive.id), newReceive)
    }
  },
  ADD_RECEIVE(state, sales) {
    state.receiveList.unshift(sales)
    state.totalCounts++
  },
    // UPDATESALES(state, sales) {
    //     Vue.set(state.sales, state.sales.findIndex(x => x._id === sales._id), sales)
    // },
  DELETE_RECEIVE(state, id) {
    state.receiveList = state.receiveList.filter(e => e._id !== id)
    state.totalCounts--
  },

  SET_RECEIVE_STAT(state, payload) {
    state.receiveStatList = payload.receiveStatList
    state.totalCounts = payload.totalCounts
  },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}